import { Switch as KobalteSwitch } from "@kobalte/core/switch"
import type { AccentHue } from "@repo/fika-design-system/color"
import { Show } from "solid-js"
import { Box } from "./box"
import {
  switchClass,
  switchControlRecipe,
  switchDescriptionClass,
  switchInputClass,
  switchLabelClass,
  switchThumb,
} from "./toggle.css"

type Props = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  hue?: AccentHue
  disabled?: boolean
  description?: string
}

export function Toggle(props: Props) {
  return (
    <KobalteSwitch
      checked={props.checked}
      onChange={props.onChange}
      disabled={props.disabled}
      class={switchClass}
    >
      <Box>
        <KobalteSwitch.Label class={switchLabelClass}>
          {props.label}
        </KobalteSwitch.Label>

        <Show when={props.description}>
          <KobalteSwitch.Description class={switchDescriptionClass}>
            {props.description}
          </KobalteSwitch.Description>
        </Show>
      </Box>

      <KobalteSwitch.Input class={switchInputClass} />
      <KobalteSwitch.Control class={switchControlRecipe({ hue: props.hue })}>
        <KobalteSwitch.Thumb class={switchThumb} />
      </KobalteSwitch.Control>
    </KobalteSwitch>
  )
}
